// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"
import "./src/styles/global.scss"
